module.exports = __webpack_public_path__ + "img/g5.24b956a8.jpg";